<template>
    <!--<img src="../../assets/guanyin.jpg" class="portrait_guanyin"/>-->
    <div style="display: flex;flex: 1 auto;flex-direction: column;height: 100%;padding: 0px 16px;">
        <div class="panel head">
            <h1>
                <Text1>关帝灵签</Text1>
            </h1>
        </div>
        <div class="panel portrait">
            <portrait style="width: 200px;height: 200px;"/>
        </div>
        <div class="panel card">
            <card v-if="show" :item="item" style="width: 100%;"></card>
        </div>
        <div class="panel" style="justify-content: center;">
            <my-button class="button" @click="onclick">抽签</my-button>
        </div>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'
    import Card from '@/components/Card'
    import Portrait from './portrait'
    import MyButton from '@/components/Button'
    import Text1 from '@/components/Text/text1'
    import { data3, } from '@/assets/data1'
    import { random } from '@/assets/utils'

    export default {
        name: 'GuanYuIndex',
        props: {},
        components: {
            MyButton,
            Portrait,
            Card,
            Text1,
        },
        setup: (props, context) => {
            const state = reactive({
                item: {},
                show: true,
                onclick: () => {
                    let data = data3

                    let n = random(0, data.length - 1)
                    state.item = data[n] || {}

                    state.show = false
                    setTimeout(() => {state.show = true}, 0)
                    // console.log(state)
                },
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .head {
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex: 0 0 60px;
        padding-top: 16px;
    }

    .panel {
        display: flex;
        margin-bottom: 16px;
    }

    .portrait {
        /*padding: 16px;*/
        overflow: hidden;
        justify-content: center;
    }

    .card {
        width: 100%;
        flex: 1 1;
        overflow: auto;

    }
</style>